import axios from 'axios'
import * as Cookies from 'js-cookie'
import handleAxiosException from './helpers'

const CancelToken = axios.CancelToken;

export const _tokenName = '__token'

export function userToken() {
  return Cookies.get( _tokenName )
}

export function removeToken() {
  return Cookies.remove( _tokenName )
}

export function userHttp( token ) {
  if ( !token ) {
    token = userToken()
  }

  const instance = axios.create()

  instance.interceptors.request.use( config => {
    config.baseURL = process.env.VUE_APP_API_URL

    if ( token ) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config;
  }, exception => {
    exception = handleAxiosException( exception )
    return Promise.reject( exception )
  } )

  return instance
}

export function userLogin( username, password ) {
  return userHttp().post( '/api/user/authenticate', {
    username: username,
    password: password
  } ).then( response => {
    const data = response.data

    if ( data.user && data.token ) {
      Cookies.set( _tokenName, data.token, { expires: 30 } )
    }
    else {
      throw new Error( 'Oops,.. The server response is incorrect, please try again later.' )
    }

    return response;
  } ).catch( exception => {
    exception = handleAxiosException( exception )

    if ( 'Network Error' == exception.message ) {
      exception.message = 'Sorry, you cannot login at this time, please try again later.'
    }

    throw exception
  } )
}

export function userLogout( token ) {
  if ( !token ) {
    token = userToken()
  }

  return userHttp( token ).post( '/api/user/logout' )
    .then( response => {
      removeToken()
      return response
    } ).catch( error => {
      removeToken()
      throw error
    } )
}

let CancelUserAuthValidation = null

export function userAuthValidation( token ) {
  if ( !token ) {
    token = userToken()
  }

  if ( CancelUserAuthValidation ) {
    CancelUserAuthValidation( 'Request cancel' );
  }

  return userHttp( token ).get( '/api/user/session/callback', {
    cancelToken: new CancelToken( cancel => {
      CancelUserAuthValidation = cancel;
    })
  } ).then( response => {
    const data = response.data;
    if ( data.token ) {
      Cookies.set( '__token', data.token )
    }

    return response;
  } ).catch( exception => {
    exception = handleAxiosException( exception )

    if ( 'Network Error' == exception.message ) {
      exception.message = 'Unable to connect to server'
    }

    throw exception
  } )
}
